import React, { useState } from 'react';
import {expensTableSTyle as styles} from "./expenseTableStyle.js";
const ExpenseStatementTable = ({ item = [],productName }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  const formatCurrency = (amount) => {
    if (amount === 0) return '₹0';
    if (amount < 0) return `-₹${Math.abs(amount).toLocaleString('en-IN')}`;
    return `₹${amount.toLocaleString('en-IN')}`;
  };

  const formatMonth = (dateString) => {
    const date = new Date(dateString);
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                       'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${monthNames[date.getMonth()]} ${date.getFullYear().toString().slice(-2)}`;
  };

  

  const calculateThirdPartyTotal = (thirdPartyData) => {
    return Object.values(thirdPartyData).reduce((sum, value) => sum + value, 0);
  };

  return (
    <div style={styles.container}>
      <div style={styles.expenseTableContainer}>
        {/* <h1 style={styles.expenseTableTitle}>Expense Table</h1> */}
                  <div style={{width:"100%",backgroundColor:"rgb(38, 49, 69)",padding:"20px",color:"white",textAlign:"center",borderTopLeftRadius:"16px",fontSize:"16px",borderTopRightRadius:"16px"}}>{productName ?? ""}</div>
        <div style={styles.tableContainer}>

          {/* Fixed Left Column */}
          <div style={styles.leftColumn}>
            <div style={{...styles.headerCell, ...styles.leftHeader}}>Particulars</div>
            
            <div style={styles.row}>
              <div style={styles.leftCell}>Technology Expense</div>
            </div>
            
            <div 
              style={{...styles.row, ...styles.expandableRow}} 
              onClick={toggleExpansion}
            >
              <div style={styles.leftCell}>Third Party API or Outsourcing Cost</div>
              <div style={{...styles.expandIcon,transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                <div style={isExpanded ? styles.arrowUp : styles.arrowDown}></div>
              </div>
            </div>
            
            <div style={{...styles.subRows,...styles.subCont, maxHeight: isExpanded ? '315px' : '0',}}>
              <div style={styles.subRow}>KYC Validation</div>
              <div style={styles.subRow}>Bank Statement Analyze</div>
              <div style={styles.subRow}>Bureau Check</div>
              <div style={styles.subRow}>Stamp Paper charges</div>
              <div style={styles.subRow}>E-mandate Charges</div>
              <div style={styles.subRow}>Esign</div>
              <div style={styles.subRow}>Retention leads cost</div>
            </div>
            
            <div style={styles.row}>
              <div style={styles.leftCell}>Administrative Expense</div>
            </div>
            
            <div style={styles.row}>
              <div style={styles.leftCell}>Employee salaries and benefits</div>
            </div>
            
            <div style={styles.row}>
              <div style={styles.leftCell}>Customer Acquisition</div>
            </div>
            
            <div style={styles.row}>
              <div style={styles.leftCell}>Interest Paid for Borrowings</div>
            </div>
            
            <div style={styles.row}>
              <div style={styles.leftCell}>Regulatory and Compliance Cost</div>
            </div>
            
            <div style={styles.row}>
              <div style={styles.leftCell}>Provisioning and Write off</div>
            </div>
            
            <div style={styles.totalRow}>Total Expense</div>
          </div>

          {/* Scrollable Right Section */}
          <div style={styles.rightColumn}>
            <div style={styles.scrollableHeader}>
              {item.map((monthData, index) => (
                <div key={index} style={{...styles.headerCell, ...styles.monthHeader,width:`calc(100%/${item?.length})`}}>
                  {formatMonth(monthData.currentMonth)}
                </div>
              ))}
            </div>
            
            <div style={styles.scrollableContent}>
              {item.map((monthData, index) => (
                <div key={index} style={{...styles.monthColumn,width:`calc(100%/${item?.length})`}}>
                  <div style={styles.dataCell}>
                    {formatCurrency(monthData.technologyExpense)}
                  </div>
                  
                  <div style={{...styles.dataCell, ...styles.dataCellThirdParty}}>
                    {formatCurrency(calculateThirdPartyTotal(monthData.thirdPartyAPICost))}
                  </div>
                  
                  <div style={{...styles.subDataColumns,...styles.subCont,maxHeight: isExpanded ? '315px' : '0',}}>
                    <div style={{...styles.subDataCell, ...(monthData.thirdPartyAPICost.kycValidation < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData.thirdPartyAPICost.kycValidation)}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.thirdPartyAPICost.bankStatementAnalyze < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData.thirdPartyAPICost.bankStatementAnalyze)}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.thirdPartyAPICost.bureauCheck < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData.thirdPartyAPICost.bureauCheck)}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.thirdPartyAPICost.stampPaperCharges < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData.thirdPartyAPICost.stampPaperCharges)}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.thirdPartyAPICost.emandateCharges < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData.thirdPartyAPICost.emandateCharges)}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.thirdPartyAPICost.esignCharges < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData.thirdPartyAPICost.esignCharges)}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.thirdPartyAPICost.retensionLeadsCost < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData.thirdPartyAPICost.retensionLeadsCost)}
                    </div>
                  </div>
                  
                  <div style={styles.dataCell}>
                    {formatCurrency(monthData.administrativeExpense)}
                  </div>
                  
                  <div style={styles.dataCell}>
                    {formatCurrency(monthData.employeeSalariesBenefits)}
                  </div>
                  
                  <div style={{...styles.dataCell, ...(monthData.customerAcquisition < 0 ? styles.dataCellNegative : {})}}>
                    {formatCurrency(monthData.customerAcquisition)}
                  </div>
                  
                  <div style={styles.dataCell}>
                    {formatCurrency(monthData.interestPaidBorrowings)}
                  </div>
                  
                  <div style={styles.dataCell}>
                    {formatCurrency(monthData.regulatoryComplianceCost)}
                  </div>
                  
                  <div style={styles.dataCell}>
                    {formatCurrency(monthData.provisioningWriteOffCost)}
                  </div>
                  
                  <div style={styles.totalCell}>
                    {formatCurrency(monthData.totalCost)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseStatementTable;